<template>
  <el-dropdown
    @click.native="handleDropdownTriggerClick"
    @command="handleCommand"
    :disabled="true"
    :trigger="trigger"
    class="er-dropdown"
  >
    <div class="er-dropdown-trigger">
      <div class="er-dropdown-trigger__prefix">
        <slot name="prefix"></slot>
      </div>
      <div class="er-dropdown-trigger__title">
        <slot name="title"></slot>
      </div>
      <div class="er-dropdown-trigger__suffix">
        <slot name="suffix">
          <i ref="icon-caret" class="el-icon-arrow-up er-icon-caret"></i>
        </slot>
      </div>
    </div>
    <el-dropdown-menu slot="dropdown" @visible="handleVisiblityChange" class="er-dropdown-menu">
      <slot name="drop-down-items">
        <el-dropdown-item v-for="(value, key) in listOfItems" :key="`list-${key}`" :command="value">
          <slot name="item-title" :item="{value,key}">{{ key }}</slot>
        </el-dropdown-item>
      </slot>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  props: {
    listOfItems: {
      required: true
    },
    popperClass: {
      type: String,
      default: ""
    },
    trigger: {
      type: String,
      default: "click"
    },
    disabled: {
      default: false
    }
  },
  methods: {
    handleCommand(command) {
      this.handleDropdownTriggerClick();
      this.$emit("item-click", command);
    },
    handleVisiblityChange(value) {
      if (this.$refs["icon-caret"]) {
        if (value) {
          this.$refs["icon-caret"].classList.add("is-reverse");
        } else {
          this.$refs["icon-caret"].classList.remove("is-reverse");
        }
      }
    },
    handleDropdownTriggerClick(value) {
      this.$emit("drop-down-trigger-click");
    }
  }
};
</script>

<style lang="scss">
.er-dropdown-menu {
  display: inline-block;
  position: relative;
  color: #606266;
  cursor: pointer;
  @include responsiveProperty(
    font-size,
    $app_font_size_1,
    $app_font_size_2,
    $app_font_size_3
  );
  .el-dropdown-menu__item {
    @include select-drop-down-item-style;
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
    @include responsiveProperty(height, 25px, 30px, 40px);
    @include responsiveProperty(line-height, 25px, 30px, 40px);

    *:not(:focus) {
      color: #606266;
      @include responsiveProperty(
        font-size,
        $app_font_size_1,
        $app_font_size_2,
        $app_font_size_3
      );
    }
    text-transform: capitalize;
    display: flex;
    align-items: center;
    .item-prefix {
      display: inline-flex;
      align-items: center;
    }
    &:focus,
    &:not(.is-disabled):hover {
      color: #606266;
    }
  }
}

.er-dropdown {
  color: #606266;
  @include responsiveProperty(
    font-size,
    $app_font_size_1,
    $app_font_size_2,
    $app_font_size_3
  );

  .er-dropdown-trigger {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
  .er-dropdown-trigger__title {
    text-transform: capitalize;
  }
  .er-dropdown-trigger__prefix,
  .er-dropdown-trigger__suffix {
    text-align: center;
  }
  .er-dropdown-trigger__prefix {
    margin-right: 10px;
  }
  .er-dropdown-trigger__suffix {
    margin-left: 10px;
    .er-icon-caret {
      transition: transform 0.3s;
      transform: rotate(180deg);
      @include responsiveProperty(
        font-size,
        $app_font_size_1,
        $app_font_size_2,
        $app_font_size_3
      );
      color: #606266;
      cursor: pointer;
      &.is-reverse {
        transform: rotate(0deg);
        @include responsiveProperty(
          font-size,
          $app_font_size_1,
          $app_font_size_2,
          $app_font_size_3
        );
        color: #606266;
      }
    }
  }
}
</style>
